import * as Yup from 'yup';

const PhoneActivationAddValidationSchema = Yup.object().shape({
  phone_number: Yup.string().required('Required')
});

export { PhoneActivationAddValidationSchema };
